import {FreeConstants} from "../../components-basic/customRoute/Endpoints/Endpoint/FreeConstants";

export const isCustomFieldValid = (length) => {
  return length < FreeConstants.customFields
}

export const isOutputValid = (length) => {
  return length < FreeConstants.outputFields
}

export const isParametersValid = (length) => {
  return length < FreeConstants.parameters
}
